import { FC, MouseEvent } from 'react'
import styled from 'styled-components'

import { OptionCheckbox, TypeStyleHeadlineExtraExtraSmall } from '@syconium/little-miss-figgy'

import {
  EmbroiderySummaryCheckbox,
  EmbroiderySummarySneakPeek,
  EmbroiderySummaryView,
} from '../../../containers/EmbroideryContainer/providers/facade'
import { EmbroiderySectionWrapper } from '../EmbroiderySectionWrapper'
import { B2bLogoSneakPeek } from '../EmbroiderySneakPeek/B2bLogoSneakPeek'
import { DTCLogoSneakPeek } from '../EmbroiderySneakPeek/DTCLogoSneakpeek'
import { IconSneakPeek } from '../EmbroiderySneakPeek/IconSneakPeek'
import { SneakPeeksListItem, SneakPeeksWrapper } from '../EmbroiderySneakPeek/styles'
import { TextSneakPeek } from '../EmbroiderySneakPeek/TextSneakPeek'

import { ActionsBar, Body, EditButton, EmbroideryLabel, RightContent } from './styles'

type Props = EmbroiderySummaryView & {
  openEmbroideryModal(event: MouseEvent<HTMLElement>): void
}

const Checkbox: FC<EmbroiderySummaryCheckbox & { name: string }> = ({
  name,
  label,
  checked,
  disabledByConflict,
  onToggle,
}) => {
  return (
    <StyledOptionCheckbox
      type='checkbox'
      name={`select-embroidery-${name}`}
      value={`select-embroidery-${name}`}
      checked={checked}
      disabled={disabledByConflict}
      onChange={() => !disabledByConflict && onToggle()}
      aria-label={label}
    />
  )
}

// TODO: These styles are meant to override the LMF styles for padding
// and hover effects. Some of these should be refactored in the LMF component
// but that is outside the scope of this work. When that happens, this can be removed.
const StyledOptionCheckbox = styled(OptionCheckbox).attrs({
  hover: false,
})`
  align-self: flex-start;
  cursor: default;
  padding: 0;

  && > input + div {
    cursor: pointer;
    margin-inline-end: 0;
    top: 0;
    opacity: 1;
  }

  // Restrict the hover check to the box itself
  && > input:not(:checked) + div:hover::before,
  && > input:not(:checked) + div:hover::after {
    background-color: ${o => o.theme.color.input.empty.content.on.background};
    display: inline;
  }
`

const SneakPeek: FC<{ sneakPeek: EmbroiderySummarySneakPeek }> = ({ sneakPeek }) => {
  switch (sneakPeek.kind) {
    case 'TEXT':
      return <TextSneakPeek {...sneakPeek.props} />
    case 'ICON':
      return <IconSneakPeek {...sneakPeek.props} />
    case 'LOGO_B2B':
      return <B2bLogoSneakPeek {...sneakPeek.props} />
    case 'LOGO_DTC':
      return <DTCLogoSneakPeek {...sneakPeek.props} />
  }
}

export const Template: FC<Props> = ({
  editEmbroideryLabel,
  editEmbroideryText,
  price,
  openEmbroideryModal,
  toggleAddEmbroideryText,
  sneakPeeks,
}) => {
  return (
    <EmbroiderySectionWrapper className='embroidery-settings-section'>
      <Body>
        <ActionsBar>
          <EmbroideryLabel>
            <TypeStyleHeadlineExtraExtraSmall>
              {toggleAddEmbroideryText}
            </TypeStyleHeadlineExtraExtraSmall>

            <EditButton
              type='button'
              onClick={openEmbroideryModal}
              aria-label={editEmbroideryLabel}
            >
              {editEmbroideryText}
            </EditButton>
          </EmbroideryLabel>
          <RightContent>{price ? <span className='money'>+{price}</span> : null}</RightContent>
        </ActionsBar>
        <SneakPeeksWrapper>
          {sneakPeeks.map(sneakPeek => (
            <SneakPeeksListItem key={sneakPeek.id}>
              <SneakPeek sneakPeek={sneakPeek} />
              {sneakPeek.checkbox && <Checkbox name={sneakPeek.id} {...sneakPeek.checkbox} />}
            </SneakPeeksListItem>
          ))}
        </SneakPeeksWrapper>
      </Body>
    </EmbroiderySectionWrapper>
  )
}
